import React from 'react'
import { useAction } from './hooks'
import { useOnClickOutside } from 'usehooks-ts'
import { setAction, submitActionStatus } from './model'
import {
  CButton,
  CForm,
  CFormInput,
  CFormLabel,
  CModal,
  CModalFooter,
} from '@coreui/react-pro'
import { GiftOrderDetail } from '../../details/types'
import { setRollback } from '../../../../billing/deposits/atoms/rollbackModal'
import { Button } from 'antd'
import { colorGiftOrderStatuses, EGiftOrderStatuses } from '../../const'

type Props = {
  data: GiftOrderDetail
  status: string
  className?: string
  color?: string
}
export const ActionChangeStatusModal: React.FC<Props> = ({
  data,
  className,
  status,
}) => {
  const { action, isLoading } = useAction()
  const [isVisible, setVisible] = React.useState(false)
  const ref = React.useRef(null)

  useOnClickOutside(ref, () => {
    if (isVisible) {
      setAction('')
    }
  })

  return (
    <>
      <Button
        className={className}
        onClick={() => setVisible(true)}
        style={{
          color: '#ffffff',
          backgroundColor: colorGiftOrderStatuses(status),
        }}
      >
        {status}
      </Button>
      <CModal visible={isVisible} onClose={() => setVisible(false)} size={'lg'}>
        <CForm
          className="row g-3 needs-validation"
          noValidate
          onSubmit={(e) => {
            const form = e.currentTarget
            e.preventDefault()
            submitActionStatus({
              status: status,
              managerComment: action,
              id: String(data.id),
            })
            setVisible(false)
          }}
          id="canceledForm"
        >
          <CModalFooter>
            <CFormLabel htmlFor="initialAmount" className="col-12">
              Reason
            </CFormLabel>
            <CFormInput
              type="text"
              id="reason"
              name="reason"
              onChange={(e) => {
                setAction(e.target.value)
              }}
            />
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cancel
            </CButton>
            <CButton
              color="primary"
              className="px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Ok
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
